<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="packerContainerForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="packerContainer" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                packerContainerForm: () => import('../forms/PackerContainerForm'),
                packerContainer: () => import('../editViews/PackerContainer'),
                headers: [
                    { text: 'Container', value: 'containerId', table: 'containers', form: () => import('../forms/ContainerForm') },
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Sampled On', value: 'sampledOn', format: this.formatDate },
                    { text: 'Floral Variety', value: 'floralVarietyId', table: 'floralVarieties', form: () => import('../forms/FloralVarietyForm') },
                    { text: 'Colour', value: 'colour', format: this.formatEnum },
                    { text: 'Odour', value: 'odour' },
                    { text: 'Taste', value: 'taste' },
                    { text: 'Moisture Percentage', value: 'moisturePercentage' },
                    { text: 'Inspected By', value: 'inspectedBy' },
                    { text: 'Approved By', value: 'approvedBy' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    containers: [],
                    floralVarieties: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "sampledOn", direction: "descending" },
                    { column: "odour", direction: "ascending" },
                    { column: "containerId", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                    { column: "floralVarietyId", direction: "ascending" },
                ],
                itemsField: 'packerContainers',
                editPageName: 'packerContainer',
                apiMethod: 'PackerContainers',
                claimName: 'PackerContainers',
                formTitle: 'Packer Container',
                excelTitle: 'Packer Containers',
                hasEditPage: true,
            }
        },
    };
</script>
